import Header from "../../Components/Header/index"
import Sustainability from "../../Components/Sustainability"

function EsgPage() {
    return (
        <main className="main">
            <Header />
            <Sustainability/>
        </main>

    )
}

export default EsgPage